export const VIDEO_INLINE_SETTING_DEFAULT = 'default';
export const VIDEO_INLINE_SETTING_NONE = 'none';
export const VIDEO_INLINE_SETTING_CUSTOM = 'custom';
